// Components
const ModalModifyTracking = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-modify-tracking" */ '@/app/views/main-view/tracking/containers/tracking-container/modals/modal-modify-tracking/modal-modify-tracking.vue');

// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js'
import { closeModalPageChangedMixins } from '@/app/mixins/utils/close-modal-page-changed-mixins.js';

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

// Services
import petService from '@/app/services/main/pets/pet-service.js';
import trackingHistoryService from '@/app/services/telstra/tracking-history/tracking-history-service.js';

export default {
	name: 'TrackingContainer',
	components: {
		ModalModifyTracking
	},
	mixins: [ 
		tableMixins,
		toastMessageMixins,
		closeModalPageChangedMixins
	],
	data() {
		return {
			isAPILoading: true,
			statusList: [{name:'ACTIVE', value: true}, {name:'INACTIVE', value: false}],
			// table
			theads: [
				{ name: 'Serial Number', searchLabel: 'f_trackingSerialNumber', sortLabel: 'trackingSerialNumber', isDesc: false, hasSearch: true, style: null},
				{ name: 'Owner Name', searchLabel: 'f_ownerName', sortLabel: 'ownerName', isDesc: false, hasSearch: true, style: null},
				{ name: 'Owner Email', searchLabel: 'f_ownerEmail', sortLabel: 'ownerEmail', isDesc: false, hasSearch: true, style: null},
				{ name: 'Pet', searchLabel: 'f_petName', sortLabel: 'petName', isDesc: false, hasSearch: true, style: 'min-width: 170px;'},
				{ name: 'Status', searchLabel: 'f_isTrackingDeviceConnected', sortLabel: 'isTrackingDeviceConnected', isDesc: false, hasStatusSearch: true, style: 'min-width: 120px'},
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: 'min-width: 100px;'}
			],
			// sorting
			desc: true,
			// modal
			modalContent: null
		}
	},
	created() {
		this.getTableContent();
	},
	methods: {
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
            page = fromFilter ? 1 : this.page;
			this.getPetTrackingDetailsList({ page, limit, sortBy, desc });
		},
		getPetTrackingDetailsList(queryParams) {
			// search filters
			if (this.columnsFilter) {
				if (this.columnsFilter.f_trackingSerialNumber) {
					queryParams['f_trackingSerialNumber'] = this.columnsFilter.f_trackingSerialNumber; 
				}
				if (this.columnsFilter.f_ownerName) {
					queryParams['f_ownerName'] = this.columnsFilter.f_ownerName;
				}
				if (this.columnsFilter.f_ownerEmail) {
					queryParams['f_ownerEmail'] = this.columnsFilter.f_ownerEmail; 
				}
				if (this.columnsFilter.f_petName) {
					queryParams['f_petName'] = this.columnsFilter.f_petName;
				}
				if (this.columnsFilter.f_isTrackingDeviceConnected) {
					queryParams['f_isTrackingDeviceConnected'] = this.columnsFilter.f_isTrackingDeviceConnected;
				}
			}
			
			this.isAPILoading = true;

			petService.getPets(queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination
						};
						this.isAPILoading = false;
					} else {
						const { ERROR_GET_PET_LIST } = this.toastMessages.pet();

						this.showAPIErrorToast(ERROR_GET_PET_LIST, res);
						this.isAPILoading = false;
					}
				});
		},
		connectDisconnectPetTracking(event, tracking) {
			// Prevent brute force toggle when there's no tracking serial number.
			if (!tracking.trackingSerialNumber) {
				return;
			}

			const displayText = tracking.trackingSerialNumber ? tracking.trackingSerialNumber : tracking.name;
			let flag = event.target.checked;
			const alertTitle = `${flag ? 'Connect' : 'Disconnect'} Tracking`;
			const alertMsg = `Are you sure you want to ${flag ? 'connect' : 'disconnect'} ${displayText}?`;

				this.$swal({
					title: alertTitle,
					text: alertMsg,
					confirmButtonText: 'Confirm',
					showCancelButton: true,
					cancelButtonText: 'Cancel',
					reverseButtons: true,
					showCloseButton: true
				})
				.then(result => {
					if (result.value) {
						this.callTrackingConnectionAPI(tracking, flag, displayText);
					} else {
						event.target.checked = !flag;
					}
				});
		},
		callTrackingConnectionAPI(tracking, flag, displayText) {
			this.isAPILoading = true;

			if (flag) {
				// API call for connect
				trackingHistoryService.connectPetTracking(tracking.id)
					.then(res => {
						const { SUCCESS_CONNECT_TRACKING, ERROR_CONNECT_TRACKING } = this.toastMessages.tracking(displayText);

						if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.showCustomSuccessToast(null, SUCCESS_CONNECT_TRACKING);
							this.isAPILoading = false;
							// refresh table with filter
							this.getTableContent();
						} else {
							this.showAPIErrorToast(ERROR_CONNECT_TRACKING, res);
							this.isAPILoading = false;
						}
					});
			} else {
				// API call for disconnect
				trackingHistoryService.disconnectPetTracking(tracking.id)
					.then(res => {
						const { SUCCESS_DISCONNECT_TRACKING, ERROR_DISCONNECT_TRACKING } = this.toastMessages.tracking(displayText);

						if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.showCustomSuccessToast(null, SUCCESS_DISCONNECT_TRACKING);
							this.isAPILoading = false;
							// refresh table with filter
							this.getTableContent();
						} else {
							this.showAPIErrorToast(ERROR_DISCONNECT_TRACKING, res);
							this.isAPILoading = false;
						}
					});
			}
		},
		showEditModal(tracking) {
			this.modalContent = tracking;
			this.$refs.modalEditTreatment.show();
		},
		deletePetSerialNumber(tracking) {
			// show modal confirmation
			this.$swal({
				title: 'Delete Serial Number',
				text: `Are you sure you want to delete ${tracking.trackingSerialNumber}?`,
				confirmButtonText: 'Confirm',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				reverseButtons: true,
				showCloseButton: true
			})
			.then(result => {
				if (result.value) {
					// API call for delete serial number
					trackingHistoryService.deleteSerialNumberTracking(tracking.id, tracking.trackingSerialNumber)
						.then(res => {
							const { SUCCESS_DELETE_TRACKING, ERROR_DELETE_TRACKING } = this.toastMessages.tracking(tracking.trackingSerialNumber);

							if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
								this.showCustomSuccessToast(null, SUCCESS_DELETE_TRACKING);
								this.isAPILoading = false;
								// refresh table with filter
								this.getTableContent();
							} else {
								this.showAPIErrorToast(ERROR_DELETE_TRACKING, res);
								this.isAPILoading = false;
							}
						});
				}
			});
		}
	}
}